    import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Calendar, Badge,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,message   } from 'antd';
import Pagination from "react-js-pagination";
import { range } from "moment-range";

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import left from '../../assets/images/icon/next.png';
import right from '../../assets/images/icon/return.png';
import add from '../../assets/images/icon/add.png';

const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

const plainOptions = ['Apple', 'Pear', 'Orange'];
const defaultCheckedList = ['Apple', 'Orange'];

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}
const item_name = [];
function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
  const item_name = checkedValues;
}



function dateCellRender(value) {
  
}

function getMonthData(value) {
  if (value.month() === 8) {
    return 1394;
  }
  
}

function monthCellRender(value) {
  const num = getMonthData(value);
  
  return num ? (
    <div className="notes-month">
     
    </div>
  ) : null;
}



class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			item_name: item_name,
			value: '',
			checkedList: defaultCheckedList,
			indeterminate: true,
			checkAll: false,
			school_list: [],
			program_list: [],
			event_list: [],
			event_type: 0,
			program_id: '',
			month: '',
			year: '',
			showYearTable: false,
			showMonthTable: false,
			showDateTable: true,
			dateObject: moment(),
			allmonths: moment.months(),
			selectedDay: null,
			page: 1,
			total_count:0,
		}
		this.getEventList = this.getEventList.bind(this);
		this.onChangePage = this.onChangePage.bind(this);
	}
	
	onChangePage=(pageNumber)=>{
	    this.setState({ page : pageNumber });
	    setTimeout(() => {
		 this.checkevent();
	    }, 500);
	}
	
	getEventList=(event_type)=>{
		this.setState({
			event_type: event_type
		});
		setTimeout(() => {
			this.checkeventmobile();
		}, 50);
	}
	
	weekdayshort = moment.weekdaysShort();
	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
		var month = this.state.dateObject.format("M");
		var monthNo = this.state.allmonths.indexOf(month);
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'],month:month,year:this.state.dateObject.format("Y") });
		setTimeout(() => {
			this.checkData();
		}, 100);
		}
		
		this.checkData();
	}
	
	openQuantity(e){
		this.setState({ program_id: e.target.value });
		setTimeout(() => {
			this.checkevent();
		}, 50);
		
	}  
	
	openQuantitymobile(e){
		this.setState({ program_id: e });
		setTimeout(() => {
			this.checkevent();
		}, 50);
		setTimeout(() => {
			this.checkeventmobile();
		}, 50);
		
	}  
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			var type = storedArray['data'][0]['type'];
			var month = this.state.month;
			var year = this.state.year;
			var app = {user_id : user_id,school_id:school_id,type:type}
			
			getData('erp/new_program_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							program_list: result['data'],
						});
					}else{
						this.setState({
							program_list: [],
							
						});
					}
					}
				});
			setTimeout(() => {
				this.checkevent();
			}, 50);	
			
	}
  }
	
	checkevent(){
		var app = {
			user_id :this.state.user_id,
			event_type:this.state.event_type,
			month:this.state.month,
			year:this.state.year,
			school_id:this.state.school_id,
			program_id:this.state.program_id,
			page:this.state.page,
			erp_id:localStorage.getItem("erp_id"),
			}
				
				getData('erp/event_list',app).then((result) => {
					let responseJson = result;
					if(responseJson.data){
						if(result['status'] == 200){
							this.setState({
								school_list: result['data'],
								total_count: result['total_school'],
							});
						}else{
							this.setState({
								school_list: [],
								total_count:0
							});
						}
					}
				});
	}
	
	checkeventmobile(){
		var app = {
			user_id :this.state.user_id,
			event_type:this.state.event_type,
			month:this.state.month,
			year:this.state.year,
			school_id:this.state.school_id,
			program_id:this.state.program_id
			}
				
				getData('erp/event_list_mobile',app).then((result) => {
					let responseJson = result;
					if(responseJson.data){
						if(result['status'] == 200){
							this.setState({
								event_list: result['data'],
							});
						}else{
							this.setState({
								event_list: [],
								
							});
						}
					}
				});
	}
	
	deleteevent(id){
		var app = {
			user_id :this.state.user_id,
			id:id,
			school_id:this.state.school_id,
			}
			getData('erp/delete_event',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					message.config({ top: 150});
					message.success('Event deleted',2);
					this.checkevent();				
				}
			});
	}
	
	handleSizeChangeNew = e => {
		this.setState({ event_type: e });
		setTimeout(() => {
			this.checkevent();
		}, 50);
		
	  };
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		setTimeout(() => {
			this.checkevent();
		}, 50);
		
	  };
	
	onChange = checkedList => {
		this.setState({
		  checkedList,
		  indeterminate: !!checkedList.length && checkedList.length < plainOptions.length,
		  checkAll: checkedList.length === plainOptions.length,
		});
	  };

  onCheckAllChange = e => {
		this.setState({
		  checkedList: e.target.checked ? plainOptions : [],
		  indeterminate: false,
		  checkAll: e.target.checked,
		});
	  };
	
	daysInMonth = () => {
    return this.state.dateObject.daysInMonth();
  };
  year = () => {
    return this.state.dateObject.format("Y");
  };
  currentDay = () => {
    return this.state.dateObject.format("D");
  };
  firstDayOfMonth = () => {
    let dateObject = this.state.dateObject;
    let firstDay = moment(dateObject)
      .startOf("month")
      .format("d"); // Day of week 0...1..5...6
    return firstDay;
  };
  month = () => {
    return this.state.dateObject.format("MMMM");
  };
  showMonth = (e, month) => {
    this.setState({
      showMonthTable: !this.state.showMonthTable,
     showDateTable: !this.state.showDateTable
    });
  };
  setMonth = month => {
    let monthNo = this.state.allmonths.indexOf(month);
    let dateObject = Object.assign({}, this.state.dateObject);
    dateObject = moment(dateObject).set("month", monthNo);
    this.setState({
      dateObject: dateObject,
      showMonthTable: !this.state.showMonthTable,
      showDateTable: !this.state.showDateTable
    });
	var mon = parseInt(monthNo) + 1;
	this.setState({
      month: mon,
    });
	setTimeout(() => {
			this.checkData();
		}, 50);
	this.checkData();
  };
  MonthList = props => {
    let months = [];
    props.data.map(data => {
      months.push(
        <td
          key={data}
          className="calendar-month"
          onClick={e => {
            this.setMonth(data);
          }}
        >
          <span>{data}</span>
        </td>
      );
    });
    let rows = [];
    let cells = [];

    months.forEach((row, i) => {
      if (i % 3 !== 0 || i == 0) {
        cells.push(row);
      } else {
        rows.push(cells);
        cells = [];
        cells.push(row);
      }
    });
    rows.push(cells);
    let monthlist = rows.map((d, i) => {
      return <tr>{d}</tr>;
    });

    return (
      <table className="calendar-month">
        <thead>
          <tr>
            <th colSpan="4">Select a Month</th>
          </tr>
        </thead>
        <tbody>{monthlist}</tbody>
      </table>
    );
  };
  showYearTable = e => {
    this.setState({
      showYearTable: !this.state.showYearTable,
      showDateTable: !this.state.showDateTable
    });
  };
  
  onPrev = () => {
    let curr = "";
    if (this.state.showYearTable === true) {
      curr = "year";
    } else {
      curr = "month";
    }
    this.setState({
      dateObject: this.state.dateObject.subtract(1, curr)
    });
	var mon = this.state.dateObject.format("MMMM");
	var monthNo = this.state.allmonths.indexOf(mon);
	var year= this.state.dateObject.format("Y");
	this.setState({
      month: parseInt(monthNo) + 1,
      year: year,
    });
	setTimeout(() => {
			this.checkData();
		}, 50);
	this.checkData();
  };
  onNext = () => {
    let curr = "";
    if (this.state.showYearTable === true) {
      curr = "year";
    } else {
      curr = "month";
    }
    this.setState({
      dateObject: this.state.dateObject.add(1, curr)
    });
	var mon = this.state.dateObject.format("MMMM");
	var monthNo = this.state.allmonths.indexOf(mon);
	var year= this.state.dateObject.format("Y");
	this.setState({
      month: parseInt(monthNo) + 1,
      year: year,
    });
	setTimeout(() => {
			this.checkData();
		}, 50);
	this.checkData();
  };
  setYear = year => {
    // alert(year)
    let dateObject = Object.assign({}, this.state.dateObject);
    dateObject = moment(dateObject).set("year", year);
    this.setState({
      dateObject: dateObject,
      showMonthTable: !this.state.showMonthTable,
      showYearTable: !this.state.showYearTable
    });
	this.setState({
      year: year,
    });
	setTimeout(() => {
			this.checkData();
		}, 50);
	this.checkData();
  };
  onYearChange = e => {
    this.setYear(e.target.value);
  };
  getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var stopDate = moment(stopDate);
    while (currentDate <= stopDate) {
      dateArray.push(moment(currentDate).format("YYYY"));
      currentDate = moment(currentDate).add(1, "year");
    }
    return dateArray;
  }
  YearTable = props => {
    let months = [];
    let nextten = moment()
      .set("year", props)
      .add("year", 12)
      .format("Y");

    let tenyear = this.getDates(props, nextten);

    tenyear.map(data => {
      months.push(
        <td
          key={data}
          className="calendar-month"
          onClick={e => {
            this.setYear(data);
          }}
        >
          <span>{data}</span>
        </td>
      );
    });
    let rows = [];
    let cells = [];

    months.forEach((row, i) => {
      if (i % 3 !== 0 || i == 0) {
        cells.push(row);
      } else {
        rows.push(cells);
        cells = [];
        cells.push(row);
      }
    });
    rows.push(cells);
    let yearlist = rows.map((d, i) => {
      return <tr>{d}</tr>;
    });

    return (
      <table className="calendar-month">
        <thead>
          <tr>
            <th colSpan="4">Select a Yeah</th>
          </tr>
        </thead>
        <tbody>{yearlist}</tbody>
      </table>
    );
  };
  
  onDayClick = (e, d) => {
		this.setState(
		  {
			selectedDay: d
		  },
		  () => {
			console.log("SELECTED DAY: ", this.state.selectedDay);
		  }
		);
	};
	
	getListData(value) {
	  let listData;
	  switch (value.date()) {
		case 8:
		  listData = [
			{ type: 'warning', content: 'This is warning event.' },
			{ type: 'success', content: 'This is usual event.' },
		  ];
		  break;
		case 10:
		  listData = [
			{ type: 'warning', content: 'A is warning event.' },
			{ type: 'success', content: 'This is usual event.' },
			{ type: 'error', content: 'This is error event.' },
		  ];
		  break;
		case 15:
		  listData = [
			{ type: 'warning', content: 'This is warning event' },
			{ type: 'success', content: 'This is very long usual event。。....' },
			{ type: 'error', content: 'This is error event 1.' },
			{ type: 'error', content: 'This is error event 2.' },
			{ type: 'error', content: 'This is error event 3.' },
			{ type: 'error', content: 'This is error event 4.' },
		  ];
		  break;
		default:
	  }
	  return listData || [];
	}
	
	dateCellRender(value) {
	  const listData = this.getListData(value);
	  return (
		<ul className="events">
		  {listData.map(item => (
			<li key={item.content}>
			  <Badge status={item.type} text={item.content} />
			</li>
		  ))}
		</ul>
	  );
	}
	
	render()
	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
					
	let weekdayshortname = this.weekdayshort.map(day => {
      return <th key={day}>{day}</th>;
    });
    let blanks = [];
    for (let i = 0; i < this.firstDayOfMonth(); i++) {
      blanks.push(<td className="calendar-day empty">{""}</td>);
    }
    let daysInMonth = [];
    for (let d = 1; d <= this.daysInMonth(); d++) {
      let currentDay = d == this.currentDay() ? "today" : "";
      daysInMonth.push(
        <td key={d} className={`calendar-day ${currentDay}`}>
          <span
            onClick={e => {
              this.onDayClick(e, d);
            }}
          >
            {d}
          </span>
        </td>
      );
    }
    var totalSlots = [...blanks, ...daysInMonth];
    let rows = [];
    let cells = [];

    totalSlots.forEach((row, i) => {
      if (i % 7 !== 0) {
        cells.push(row);
      } else {
        rows.push(cells);
        cells = [];
        cells.push(row);
      }
      if (i === totalSlots.length - 1) {
        // let insertRow = cells.slice();
        rows.push(cells);
      }
    });

    let daysinmonth = rows.map((d, i) => {
      return <tr>{d}</tr>;
    });				
	

	const lenght = this.state.school_list.length;
		return (
			<div class="mobile_view">
			
			<div class="row bred">
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<h4 class="page-title"> 
								<i class="mdi mdi-apple-keyboard-command title_icon"></i> Calendar
								<Link to={`${process.env.PUBLIC_URL}/calendar/add-event`} className="btn btn-outline-primary btn-rounded alignToTitle"><i class="mdi mdi-plus"></i> Add 
								</Link>
								<div class="breadcrumb-wrapper">
									<ol class="breadcrumb">
										<li class="breadcrumb-item">
											<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
											<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
											</a>
										</li>
										<li class="breadcrumb-item"> Calendar </li>
									</ol>
								</div>
							</h4>
						</div>
					</div>
				</div>
			</div>
			
			<div class="row">
				<div class="col-md-12">
				<div class="card">
				<div class="card-body">
					<div class="form-group">
						<label  style={{paddingTop: '8px',paddingRight:'10px',float:'left'}}><b>Select Class</b></label>
						 <select style={{float:'left'}} placeholder="Select Class" value={this.state.program_id} name="program_id" id="program_id" className="form-control changeSchool" onChange={this.openQuantity.bind(this)}>
							<option value="">All</option>
							{this.state.program_list.map((list)=>(
								
								<option value={list.id}>{list.name}</option>
							))}	
						 </select>
					</div>
				</div>
				</div>
				</div>
			</div>
				
			<div class="row">
				<div class="card-body">
					<ul class="nav nav-tabs nav-tabs-solid">
						<li class="nav-item"><a href="javascript:void(0)" onClick={this.handleSizeChangeNew.bind(this,0)} class={`nav-link  ${this.state.event_type == 0 ? 'active':'a'}`}>All</a></li>
						
						<li class="nav-item"><a href="javascript:void(0)" onClick={this.handleSizeChangeNew.bind(this,3)} class={`nav-link  ${this.state.event_type == 3 ? 'active':'a'}`}>Birthday</a></li>
						
						<li class="nav-item"><a href="javascript:void(0)" onClick={this.handleSizeChangeNew.bind(this,6)} class={`nav-link  ${this.state.event_type == 6 ? 'active':'a'}`}>Staff Birthday</a></li>
						
						<li class="nav-item"><a href="javascript:void(0)" onClick={this.handleSizeChangeNew.bind(this,1)} class={`nav-link  ${this.state.event_type == 1 ?'active':'a'}`}>Events</a></li>
						
						<li class="nav-item"><a href="javascript:void(0)" onClick={this.handleSizeChangeNew.bind(this,2)} class={`nav-link  ${this.state.event_type == 2 ?'active':'a'}`}>Holidays</a></li>
						
						<li class="nav-item"><a href="javascript:void(0)" onClick={this.handleSizeChangeNew.bind(this,4)} class={`nav-link  ${this.state.event_type == 4 ?'active':'a'}`}>Celebrations</a></li>
						
						<li class="nav-item"><a href="javascript:void(0)" onClick={this.handleSizeChangeNew.bind(this,5)} class={`nav-link  ${this.state.event_type == 5 ?'active':'a'}`}>PTM</a></li>
					</ul>
				</div>
			</div>	
			
			
		
			
			
			   <div class="row">
			   <div class="card-body">
			   <div class=" calendar ">
                
					
						<div className="tail-datetime-calendar iq-card2 ">
						<div className="calendar-navi">
						  <span
							onClick={e => {
							  this.onPrev();
							}}
							class="calendar-button button-prev"
						  />
						  {!this.state.showMonthTable && (
							<span
							  onClick={e => {
								this.showMonth();
							  }}
							  class="calendar-label"
							>
							  {this.month()}
							</span>
						  )}
						  <span className="calendar-label" onClick={e => this.showYearTable()}>
							{this.year()}
						  </span>
						   <span
						  onClick={e => {
							this.onNext();
						  }}
						  className="calendar-button button-next"
						/>
						</div>
					   
						<div className="calendar-date">
						  {this.state.showYearTable && <this.YearTable props={this.year()} />}
						  {this.state.showMonthTable && (
							<this.MonthList data={moment.months()} />
						  )}
						</div>

						{this.state.showDateTable && (
						  <div className="calendar-date">
							<table className="calendar-day">
							  <thead>
								<tr>{weekdayshortname}</tr>
							  </thead>
							  <tbody>{daysinmonth}</tbody>
							</table>
						  </div>
						)}
					  </div> 
					</div>	
					</div>
					</div>	
					
                 
              
               
			<div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3">
					 <div class="card">
						<div class="card-body">
						
						<h4 class="mb-3 header-title">
						Total : {this.state.total_count}
						
						</h4>
						
						
                        <div class="table-responsive">
                           <table class="table table-striped table-bordered table-hover">
                              <thead>
                                 <tr>
                                    <th>#</th>
                                    <th><span >Type</span></th>
									<th>Title</th>
									<th>Start Date</th>
									<th>End Date</th>
									<th>Option</th>
                                 </tr>
                              </thead>
                              <tbody>
							  {this.state.school_list.length == 0 && (<><tr><td colspan="8" class="text-center">No Data Found</td></tr></>)}
							  {this.state.school_list.map((list,index) => (
                                 <tr>
									<td>{index+1}</td>
                                    <td><span className={list.color}><b>{list.type_name}</b></span></td>
								    <td>{list.title}</td>
								    <td>{list.start_date}</td>
								    <td>{list.end_date}</td>
                                    <td>
										{list.type_name !='Birthday' && (<>
											<div class="dropright dropright">
												<button type="button" class="btn btn-sm btn-outline-primary btn-rounded btn-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
													<i class="mdi mdi-dots-vertical"></i>
												</button>
												<ul class="dropdown-menu">
													<li>
														<Link class="dropdown-item" to={`${process.env.PUBLIC_URL}/calendar/edit-event/${list.id}`}>
															<i class="ri-edit-line"></i> View & Edit
														</Link>
														<a class="dropdown-item" href="javascript:void(0)"  onClick={this.deleteevent.bind(this,list.id)}>
															<i class="ri-delete-bin-line"></i> Delete
														</a>
													</li>
												</ul>
											</div>
										</>)}
										
                                    </td>
                                 </tr>
								 ))}
                                
                              </tbody>
                           </table>
						   <div class="fl-right">
								<Pagination
									activePage={this.state.page}
									itemsCountPerPage={10}
									totalItemsCount={this.state.total_count}
									pageRangeDisplayed={3}
									onChange={this.onChangePage.bind(this)}
								/>
							</div>
                        </div>
                        </div>
                        </div>
                     </div>
                  </div>
               </div>
	</div>
     
		) 
	} 
}
export default Index;
